// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --background: #efefef;
}

ion-grid {
  padding: 0 0 12% 0;
  height: 100%;
  display: flex;
  flex-direction: column;
}
ion-grid ion-icon {
  color: #ed143d;
}
ion-grid .map-filters {
  background-color: white;
  margin: 5px 10px;
  border-radius: 12px;
  overflow: hidden;
}
ion-grid .map-filters ion-col {
  padding: 0;
}
ion-grid .map-filters ion-col ion-item {
  --inner-padding-start: 16px;
}
ion-grid .map-filters ion-col ion-item:not(:last-child) ion-select {
  border-bottom: 1px solid #eee;
}
ion-grid .reset-button-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-block: 10px;
  color: #ed143d;
  margin: 5px 10px;
}

ion-select::part(label) {
  font-weight: 600;
  font-size: 16px;
}

ion-select::part(container) {
  font-size: 15px;
}

ion-select::part(icon) {
  color: #ed143d;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/search/floorplan-searchpopover/floorplan-searchpopover.component.scss"],"names":[],"mappings":"AACA;EACI,qBAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAAJ;AACI;EACI,cAAA;AACR;AACI;EACI,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AACR;AAAQ;EACI,UAAA;AAEZ;AADY;EACI,2BAAA;AAGhB;AADgB;EACI,6BAAA;AAGpB;AAGI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AADN;;AAMA;EAEI,gBAAA;EACA,eAAA;AAJJ;;AAOA;EACI,eAAA;AAJJ;;AAOA;EACI,cAAA;AAJJ","sourcesContent":["\nion-content {\n    --background: #efefef;\n  }\n  \nion-grid {\n    padding: 0 0 12% 0;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    ion-icon {\n        color:#ed143d\n    }\n    .map-filters {\n        background-color: white;\n        margin: 5px 10px;\n        border-radius: 12px;\n        overflow: hidden;\n        ion-col {\n            padding: 0;\n            ion-item {\n                --inner-padding-start: 16px;\n                &:not(:last-child) {\n                ion-select {\n                    border-bottom: 1px solid #eee;  \n                }\n            }\n            }\n        }\n    }\n    .reset-button-container {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      padding-block: 10px;\n      color: #ed143d;\n      margin: 5px 10px;\n      \n    }\n}\n\nion-select::part(label) {\n    // color: #888;\n    font-weight: 600;\n    font-size: 16px;\n}\n\nion-select::part(container) {\n    font-size: 15px;\n}\n\nion-select::part(icon) {\n    color: #ed143d;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
